import { useDispatch, useSelector } from 'react-redux';
import { selectedMetricChart, setMetrics } from '@src/store/metricsChartContainer/actions';
import { getInvertedPercentageMetricByKey } from '@src/utils/metrics/metricHelpers';
import { metricSelector } from '@src/store/metricsChartContainer/selectors';

const useSelectMetric = () => {
  const dispatch = useDispatch();
  const selectedMetricsFromStore = useSelector(metricSelector);

  return (metricKey) => {
    const newMetric = getInvertedPercentageMetricByKey({
      metricKey: metricKey,
      defaultValue: metricKey,
    });

    // add selected metric to chart section
    if (!selectedMetricsFromStore.includes(newMetric)) {
      dispatch(setMetrics([newMetric, ...selectedMetricsFromStore]));
    }

    // set as selected metric
    dispatch(selectedMetricChart(newMetric, undefined, true));
  };
};

export default useSelectMetric;
